import { styled } from '@slal/ui';
import { LoadingDots } from '@slal/ui/animations';
import { breakpointUp } from '@slal/ui/helpers';
import { Heading } from '@slal/ui/typography';

export const StyledHeading = styled(Heading)`
    color: ${({ theme }) => theme.colors.neutral__light__00};
    font-size: ${({ theme }) => theme.fontSizes[11]};
`;

export const StyledContent = styled.div`
    h1,
    h2 {
        margin-bottom: 0;
    }
    h4 {
        font-weight: 400;
        margin-bottom: ${({ theme }) => theme.space[4]};
    }
    ${StyledHeading} {
        margin-bottom: ${({ theme }) => theme.space[0]};
    }
`;

export const StyledPageLoadingDots = styled(LoadingDots)`
    display: flex;
    height: 50vh;
    align-items: center;
    justify-content: center;
`;

export const DisplayMobile = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    ${breakpointUp.lg`
        display:none;    
    `}
`;

export const DisplayDesktop = styled.div`
    display: none;
    ${breakpointUp.lg`
        display: flex;
        flex-direction: column;
        gap: 16px;    
    `}
`;

export const MaxWidthContent = styled.section`
    ${breakpointUp.lg`
        max-width: 512px;
    `}
    ${breakpointUp.xl`
        max-width: 660px;
    `}
`;

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
`;

export const StyledActionLinkWrapper = styled.div`
    ${breakpointUp.md`
        max-width: 320px;
    `}
    a, button {
        display: block;
        width: 100%;
        text-decoration: none;
    }
`;

export const FormLayout = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;

    ${breakpointUp.lg`
        flex-direction: row;
        gap: 64px;

        > * {
            flex: 1; 
            max-width: 50%;
        }
    `}
`;
